export function getReferrerHostname(referrer) {
    referrer = referrer || (typeof document !== 'undefined' ? document.referrer : '');
    if (!referrer) return null;
    const referrerHostMatch = referrer.match("://([^/?#$]*)");
    if (!referrerHostMatch || !referrerHostMatch[1]) return null;
    return referrerHostMatch[1];
}

export function getSearchEngine(referrerHostname) {
    if (!referrerHostname) return null;
    const match = referrerHostname.match(
        /(google|bing|yandex|baidu|yahoo)\.[a-zA-Z]{2,3}$/
    );
    if (match) {
        return match[1];
    }
    return null;
}

export function isExternal(referrerHostname, domain) {
    domain = domain || (typeof location !== 'undefined' ? location.hostname : '');
    if (!referrerHostname || !domain) return false;
    return !referrerHostname.includes(domain);
}

export function getURLParams() {
    const params = {};
    if (typeof window === 'undefined' || !window.location || !window.location.search) {
        return params;
    }
    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams.entries()) {
        params[key] = value;
    }
    return params;
}

export function setURLParamsInStore(store, urlParams) {
    /* Inplace */
    Object.keys(store).forEach(function (storeKey) {
        if (!urlParams[storeKey]) return;
        store[storeKey] = urlParams[storeKey];
    });
}

export function shouldSaveStore(store, savedValues, urlParams) {
    // No utm_source currently saved
    if (!savedValues) return true;
    if (!savedValues.utm_source) return true;

    // Explicit source / campaign in url params
    if (urlParams && (urlParams.utm_source || urlParams.utm_campaign)) return true;

    // Bigger numbers overwrite smaller numbers
    const prioMapMedium = {
        // Category 1
        null: 1,
        undefined: 1,
        "": 1,
        "(direct)": 1,
        "(none)": 1,
        organic: 2,
        referral: 2,
        display: 2,
        postview: 2,
        cpc: 2,
    };
    // Default: Infinity
    const savedMediumPriority =
        prioMapMedium[savedValues.utm_medium] || Infinity;
    const newMediumPriority = prioMapMedium[store.utm_medium] || Infinity;
    return newMediumPriority >= savedMediumPriority;
}

export function fetchAndStoreUTMParameters(storage) {
    if (!storage) return;

    // Init store with default values
    const _store = {
        utm_source: "(direct)",
        utm_medium: "(none)",
        utm_campaign: "(none)",
        utm_content: "(none)",
        utm_term: "(none)",
    };

    const exlusionItems =
        "paypal|sofort|crefopay|perfdrive|klarna|girogate|ing.de|mollie|3dsecure|3ds|commerzbank|consorsbank|stripe|mastercard|visa|pay1|payments.amazon.de|pay.mondu.ai|payments.amazon".split(
            "|"
        );

    const referrer = typeof document !== 'undefined' ? document.referrer : '';
    const referrerHostname = getReferrerHostname(referrer);
    if (
        referrerHostname &&
        (exlusionItems.some((item) => referrerHostname.includes(item)) ||
            referrerHostname.includes("recover.votregateau.fr"))
    ) {
        return;
    }

    if (isExternal(referrerHostname)) {
        const searchEngine = getSearchEngine(referrerHostname);
        if (searchEngine) {
            _store.utm_source = searchEngine;
            _store.utm_medium = "organic";
        } else {
            _store.utm_source = referrerHostname;
            _store.utm_medium = "referral";
        }
    }

    const urlParams = getURLParams();

    if (urlParams.gclid) {
        _store.utm_source = "google";
        _store.utm_medium = "cpc";
    }

    setURLParamsInStore(_store, urlParams);

    const savedValues = getStoredUTMParameters(storage);

    if (shouldSaveStore(_store, savedValues, urlParams)) {
        _store.utm_click_ts = new Date().toISOString();
        _store.__saved_at__ = Date.now();
        storage.set("ph_utm_data", JSON.stringify(_store));
    }
}

export function getStoredUTMParameters(storage) {
    if (!storage) return {};
    const raw = storage.get('ph_utm_data');
    if (!raw) return {};
    try {
        return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
        return {};
    }
}
